export default __webpack_public_path__ + "static/media/card-08.eec0058e.svg";